module.exports = __webpack_public_path__ + "img/hotel.e189cd01.jpeg";